// import {
//   Image,
//   Target,
//   Layers,
//   Zap,
//   Eye,
//   BarChart3,
//   Award,
//   CheckCircle2,
//   ArrowRight,
// } from "lucide-react";

// export default function ImagePhotoPage() {
//   const datasets = [
//     {
//       title: "Object Detection",
//       samples: "500K+",
//       desc: "Annotated objects with bounding boxes",
//     },
//     {
//       title: "Semantic Segmentation",
//       samples: "300K+",
//       desc: "Pixel-level semantic annotations",
//     },
//     {
//       title: "Instance Segmentation",
//       samples: "250K+",
//       desc: "Individual object instance masks",
//     },
//     {
//       title: "Scene Understanding",
//       samples: "400K+",
//       desc: "Complex scene annotations",
//     },
//     {
//       title: "Medical Imaging",
//       samples: "200K+",
//       desc: "Annotated medical and X-ray images",
//     },
//     {
//       title: "Facial Recognition",
//       samples: "1M+",
//       desc: "Face detection and landmarks data",
//     },
//   ];

//   const features = [
//     {
//       icon: Image,
//       title: "4K+ Resolution",
//       desc: "High-quality images suitable for training",
//     },
//     {
//       icon: Target,
//       title: "Precise Annotations",
//       desc: "Expert-labeled with multiple annotation types",
//     },
//     {
//       icon: Layers,
//       title: "Diverse Categories",
//       desc: "100+ object categories and scenarios",
//     },
//     {
//       icon: Eye,
//       title: "Quality Verified",
//       desc: "Multi-level QA for annotation accuracy",
//     },
//   ];

//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* Hero Section - Professional */}
//       <section
//         style={{
//           background: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.76),
//         rgba(0, 0, 0, 0.76)
//       ),
//       url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80')
//     `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "75px 20px", // ⬅️ reduced height
//             color: "white",
//           }}
//         >
//           <div style={{ maxWidth: "720px" }}>
//             {/* Badge */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginBottom: "16px",
//                 background: "rgba(59,130,246,0.14)",
//                 border: "1px solid rgba(59,130,246,0.35)",
//                 padding: "8px 14px",
//                 borderRadius: "6px",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: "12px",
//                   fontWeight: 600,
//                   letterSpacing: "1px",
//                   color: "#93c5fd",
//                 }}
//               >
//                 ENTERPRISE COMPUTER VISION DATASETS
//               </span>
//             </div>

//             {/* Title */}
//             <h1
//               style={{
//                 fontSize: "44px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 lineHeight: "1.15",
//                 letterSpacing: "-0.4px",
//               }}
//             >
//               Professional Image & Photo Dataset Services
//             </h1>

//             {/* Description */}
//             <p
//               style={{
//                 fontSize: "16px",
//                 color: "#cbd5e1",
//                 marginBottom: "26px",
//                 lineHeight: "1.55",
//                 maxWidth: "600px",
//                 opacity: 0.95,
//               }}
//             >
//               Large-scale, high-quality image datasets with expert annotations
//               for computer vision and deep learning projects with
//               enterprise-grade quality assurance.
//             </p>

//             {/* Actions */}
//             <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
//               <button
//                 style={{
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "none",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//               >
//                 Browse Datasets <ArrowRight size={16} />
//               </button>

//               <button
//                 style={{
//                   background: "transparent",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "1.5px solid rgba(255,255,255,0.35)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Request Demo
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Key Stats */}
//       <section style={{ padding: "60px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {[
//               { value: "2.5M+", label: "Total Images" },
//               { value: "100+", label: "Object Classes" },
//               { value: "50M+", label: "Annotations" },
//               { value: "99.5%", label: "Annotation Accuracy" },
//             ].map((stat, index) => (
//               <div key={index} style={{ textAlign: "center", padding: "24px" }}>
//                 <div
//                   style={{
//                     color: "#3b82f6",
//                     fontSize: "36px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   {stat.value}
//                 </div>
//                 <div
//                   style={{
//                     color: "#64748b",
//                     fontSize: "14px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   {stat.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Dataset Features
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {features.map((feature, index) => {
//               const Icon = feature.icon;
//               return (
//                 <div
//                   key={index}
//                   style={{
//                     display: "flex",
//                     gap: "20px",
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   <div
//                     style={{
//                       backgroundColor: "#3b82f6",
//                       color: "white",
//                       width: "56px",
//                       height: "56px",
//                       borderRadius: "8px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Icon size={26} />
//                   </div>
//                   <div>
//                     <h3
//                       style={{
//                         fontSize: "18px",
//                         fontWeight: "700",
//                         marginBottom: "8px",
//                         color: "#1a202c",
//                       }}
//                     >
//                       {feature.title}
//                     </h3>
//                     <p
//                       style={{
//                         color: "#64748b",
//                         fontSize: "14px",
//                         lineHeight: "1.6",
//                       }}
//                     >
//                       {feature.desc}
//                     </p>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Dataset Categories */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Available Datasets
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {datasets.map((dataset, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#ffffff",
//                   border: "1px solid #e5e7eb",
//                   padding: "28px",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                 }}
//               >
//                 <div
//                   style={{
//                     color: "#3b82f6",
//                     fontSize: "13px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                     letterSpacing: "0.5px",
//                   }}
//                 >
//                   {dataset.samples}
//                 </div>
//                 <h3
//                   style={{
//                     fontSize: "20px",
//                     fontWeight: "700",
//                     marginBottom: "12px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {dataset.title}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#64748b",
//                     marginBottom: "20px",
//                     fontSize: "14px",
//                     lineHeight: "1.6",
//                   }}
//                 >
//                   {dataset.desc}
//                 </p>
//                 <button
//                   style={{
//                     color: "#3b82f6",
//                     borderColor: "#3b82f6",
//                     border: "2px solid",
//                     padding: "10px 24px",
//                     borderRadius: "6px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     backgroundColor: "transparent",
//                     cursor: "pointer",
//                     width: "100%",
//                   }}
//                 >
//                   Explore
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Annotation Types */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Annotation Types
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {[
//               {
//                 title: "Bounding Boxes",
//                 desc: "Object localization",
//                 points: [
//                   "Precise coordinates",
//                   "Multi-object support",
//                   "Class labels",
//                 ],
//               },
//               {
//                 title: "Semantic Segmentation",
//                 desc: "Pixel-level classification",
//                 points: [
//                   "Full image segmentation",
//                   "Class mapping",
//                   "Boundary precision",
//                 ],
//               },
//               {
//                 title: "Instance Segmentation",
//                 desc: "Individual object masks",
//                 points: [
//                   "Object isolation",
//                   "Instance IDs",
//                   "Overlap handling",
//                 ],
//               },
//               {
//                 title: "Keypoints",
//                 desc: "Landmark detection",
//                 points: ["Pose estimation", "Facial landmarks", "Body joints"],
//               },
//               {
//                 title: "Panoptic Segmentation",
//                 desc: "Semantic + instance",
//                 points: ["Stuff & things", "Complete coverage", "Instance IDs"],
//               },
//               {
//                 title: "3D Annotations",
//                 desc: "Three-dimensional data",
//                 points: ["Point clouds", "Cuboid boxes", "Mesh annotations"],
//               },
//             ].map((type, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#f9fafb",
//                   padding: "28px",
//                   borderRadius: "8px",
//                   border: "1px solid #e5e7eb",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "700",
//                     marginBottom: "6px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {type.title}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#3b82f6",
//                     fontWeight: "600",
//                     marginBottom: "16px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {type.desc}
//                 </p>
//                 <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                   {type.points.map((point, idx) => (
//                     <li
//                       key={idx}
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         marginBottom: "8px",
//                         alignItems: "flex-start",
//                       }}
//                     >
//                       <CheckCircle2
//                         size={16}
//                         style={{
//                           color: "#3b82f6",
//                           flexShrink: 0,
//                           marginTop: "2px",
//                         }}
//                       />
//                       <span style={{ color: "#64748b", fontSize: "13px" }}>
//                         {point}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Use Cases */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Common Applications
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "20px",
//             }}
//           >
//             {[
//               "Autonomous Vehicles",
//               "Surveillance & Security",
//               "Medical Image Analysis",
//               "E-Commerce Product Recognition",
//               "Robotics & Automation",
//               "Satellite Imagery Analysis",
//               "Sports Analytics",
//               "Quality Control & Inspection",
//             ].map((useCase, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#ffffff",
//                   borderLeft: "3px solid #3b82f6",
//                   padding: "20px",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                 }}
//               >
//                 <BarChart3
//                   size={22}
//                   style={{ color: "#3b82f6", flexShrink: 0 }}
//                 />
//                 <p
//                   style={{
//                     color: "#1a202c",
//                     fontWeight: "600",
//                     fontSize: "15px",
//                     margin: 0,
//                   }}
//                 >
//                   {useCase}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* QA Process */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Quality Assurance Process
//           </h2>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "24px",
//               maxWidth: "800px",
//               margin: "0 auto",
//             }}
//           >
//             {[
//               {
//                 num: "1",
//                 title: "Image Collection",
//                 desc: "Source diverse high-quality images",
//               },
//               {
//                 num: "2",
//                 title: "Initial Annotation",
//                 desc: "First pass annotation by experts",
//               },
//               {
//                 num: "3",
//                 title: "Verification",
//                 desc: "Independent reviewer checks",
//               },
//               {
//                 num: "4",
//                 title: "Consensus Review",
//                 desc: "Multi-annotator agreement",
//               },
//               {
//                 num: "5",
//                 title: "Final QA",
//                 desc: "Quality metrics validation",
//               },
//               {
//                 num: "6",
//                 title: "Delivery",
//                 desc: "Format conversion and packaging",
//               },
//             ].map((step, index) => (
//               <div
//                 key={index}
//                 style={{
//                   display: "flex",
//                   gap: "20px",
//                   alignItems: "flex-start",
//                 }}
//               >
//                 <div
//                   style={{
//                     backgroundColor: "#3b82f6",
//                     color: "white",
//                     width: "48px",
//                     height: "48px",
//                     borderRadius: "8px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                     fontWeight: "700",
//                     fontSize: "18px",
//                   }}
//                 >
//                   {step.num}
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <h3
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "700",
//                       marginBottom: "6px",
//                       color: "#1a202c",
//                     }}
//                   >
//                     {step.title}
//                   </h3>
//                   <p
//                     style={{
//                       color: "#64748b",
//                       fontSize: "14px",
//                       lineHeight: "1.6",
//                     }}
//                   >
//                     {step.desc}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA - Professional */}
//       <section
//         style={{
//           backgroundColor: "#1e293b",
//           padding: "80px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "800px",
//             margin: "0 auto",
//             textAlign: "center",
//             padding: "0 20px",
//           }}
//         >
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "700",
//               marginBottom: "16px",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             Need Custom Image Datasets?
//           </h2>
//           <p
//             style={{
//               fontSize: "16px",
//               color: "#cbd5e1",
//               marginBottom: "32px",
//               lineHeight: "1.6",
//             }}
//           >
//             Contact our team to discuss your computer vision project
//             requirements and receive a customized dataset proposal with
//             enterprise-grade quality assurance.
//           </p>
//           <div
//             style={{
//               display: "flex",
//               gap: "16px",
//               justifyContent: "center",
//               flexWrap: "wrap",
//             }}
//           >
//             <button
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 backgroundColor: "#3b82f6",
//                 color: "white",
//                 padding: "14px 32px",
//                 borderRadius: "6px",
//                 fontWeight: "600",
//                 fontSize: "15px",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Get in Touch <ArrowRight size={18} />
//             </button>
//             <button
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 backgroundColor: "transparent",
//                 color: "white",
//                 padding: "14px 32px",
//                 borderRadius: "6px",
//                 fontWeight: "600",
//                 fontSize: "15px",
//                 border: "2px solid rgba(255, 255, 255, 0.2)",
//                 cursor: "pointer",
//               }}
//             >
//               View Samples
//             </button>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  Image,
  Target,
  Layers,
  Zap,
  Eye,
  CheckCircle2,
  ArrowRight,
  ShieldCheck,
  Maximize,
  Scan,
  Box,
  Shapes,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function ImagePhotoPage() {
  const datasets = [
    {
      title: "Object Detection",
      desc: "Annotated objects with precise bounding boxes for localization.",
    },
    {
      title: "Semantic Segmentation",
      desc: "Pixel-level semantic labels for dense scene understanding.",
    },
    {
      title: "Instance Segmentation",
      desc: "Individual object instance masks for discrete tracking.",
    },
    {
      title: "Scene Understanding",
      desc: "Context-aware annotations for complex environmental analysis.",
    },
    {
      title: "Medical Imaging",
      desc: "Specialized diagnostic annotations for X-ray, MRI, and CT data.",
    },
    {
      title: "Biometric Data",
      desc: "Facial detection, landmarks, and high-fidelity mapping.",
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Subtle Tech Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Computer Vision Infrastructure
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Visual Data</span>{" "}
              Systems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              Large-scale, high-fidelity image datasets with expert pixel-level
              annotations engineered for mission-critical computer vision and
              deep learning architectures.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Explore Datasets <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= TECHNICAL CAPABILITIES (ALIGNED IMAGE) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <motion.div {...fadeUp} className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight">
                  Vision-Grade Engineering
                </h2>
                <p className="text-slate-600 leading-relaxed font-light text-lg">
                  AI performance is bottlenecked by annotation precision. Our
                  computer vision pipelines utilize multi-stage
                  human-in-the-loop verification to ensure pixel-perfect ground
                  truth.
                </p>
              </div>

              <div className="grid gap-6">
                {[
                  {
                    icon: Maximize,
                    t: "High-Resolution Sourcing",
                    d: "4K+ raw imaging data suitable for autonomous and medical-grade training.",
                  },
                  {
                    icon: Target,
                    t: "Precise Multi-Type Labelling",
                    d: "Bounding boxes, polygons, and keypoint mapping with sub-pixel accuracy.",
                  },
                  {
                    icon: ShieldCheck,
                    t: "Quality Verification",
                    d: "Three-tier QA including independent verification and multi-annotator consensus.",
                  },
                ].map((item, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="shrink-0 w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center text-indigo-600">
                      <item.icon size={20} />
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-900">
                        {item.t}
                      </h4>
                      <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                        {item.d}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Right Image (Height Matched to Content) */}
            <div className="relative">
              <div className="absolute -inset-4 bg-indigo-100/50 rounded-3xl -z-10 blur-2xl opacity-50" />
              <div className="overflow-hidden rounded-2xl shadow-2xl border border-slate-100 h-[400px] lg:h-[480px]">
                <img
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80"
                  alt="Computer Vision Analysis"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= DATASET CATEGORIES (REFINED CARDS) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Service Catalog
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Available Data Categories
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {datasets.map((dataset, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 bg-white rounded-2xl border border-slate-200 hover:border-indigo-500/30 hover:shadow-xl transition-all duration-300 text-left relative overflow-hidden"
              >
                <div className="relative z-10">
                  <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                    {dataset.title}
                  </h3>
                  <p className="text-[13px] text-slate-500 leading-relaxed font-light mb-6">
                    {dataset.desc}
                  </p>
                  <a
                    href="/contact"
                    className="flex items-center gap-2 text-[11px] font-bold text-slate-900 uppercase tracking-tighter group-hover:gap-3 transition-all"
                  >
                    Spec Sheet <ArrowRight size={14} />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= ANNOTATION TYPES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Technical Annotation Formats
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: Box,
                t: "Bounding Boxes",
                d: "2D/3D object localization for high-speed detection.",
              },
              {
                icon: Shapes,
                t: "Pixel Segmentation",
                d: "Dense semantic labelling for environmental navigation.",
              },
              {
                icon: Scan,
                t: "Keypoint Analysis",
                d: "Landmark detection for pose estimation and biometrics.",
              },
              {
                icon: Layers,
                t: "Panoptic Maps",
                d: "Unified instance and semantic segmentation schemas.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:bg-white hover:shadow-md transition-all group text-left"
              >
                <item.icon
                  className="text-indigo-600 mb-4 group-hover:scale-110 transition-transform"
                  size={24}
                />
                <h4 className="font-bold text-slate-900 text-sm mb-2">
                  {item.t}
                </h4>
                <p className="text-xs text-slate-500 leading-relaxed font-light">
                  {item.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Custom Visual Acquisition.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Need a specific dataset for autonomous robotics or medical research?
            Our expert annotation teams provide tailored data collection
            globally.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl shadow-black/20"
            >
              Initiate Technical Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}